import { ImgHTMLAttributes } from "react";
import tcbase from "../../shim/tcbase";

const { urls: { static: root = "static" } = {} } = tcbase ?? {};

const TYPE_FOLDER_MAP = {
  FLAGS: "flags",
  FILE_TYPE: "file_types-source",
  FILE_CLASSIFICATION: "file_types-source-classification",
  NETWORK_CLASSIFICATION: "images/network_classification_images"
};

type TypeFolderKey = keyof typeof TYPE_FOLDER_MAP;

interface Props extends ImgHTMLAttributes<HTMLImageElement> {
  type?: TypeFolderKey;
  name?: string;
  fileType?: "png" | "svg";
}

const Image = ({
  type = "FILE_TYPE",
  name = "default",
  fileType = "png",
  ...rest
}: Props) => {
  const folder = TYPE_FOLDER_MAP[type];
  const location = `${root}${folder}/${name}.${fileType}`;
  return <img src={rest.src ?? location} {...rest} />;
};

export default Image;
